// src/components/Campaigns/campaignsUtils.js
import { Chip } from "@mui/material";
import React from 'react'; // Import React to use JSX for Chip

export const formatCurrency = (amount) => {
  if (isNaN(amount) || amount === null) return "UGX 0";
  const roundedAmount = Math.round(amount);
  return `UGX ${roundedAmount.toLocaleString("en-US")}`;
};

export const getStatusChip = (status) => {
  let color;
  let label = status;
  switch (status) {
    case "open":
      color = "success";
      label = "Active";
      break;
    case "closed":
      color = "error";
      label = "Closed";
      break;
    case "pending": // Assuming you might have a pending state
      color = "warning";
      label = "Pending";
      break;
    default:
      color = "default";
      label = "Unknown";
  }
  return <Chip label={label} color={color} size="small" variant="outlined" />;
};

export const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
    });
};